import { GeoJSONSource, GeoJSONSourceSpecification, Map } from "maplibre-gl";

export const setSources = (map: Map, sources: Record<string, GeoJSONSourceSpecification>) => {
    if (!map) return;
    for (const [sourceId, source] of Object.entries(sources)) {
        try {
            if (source) {
                const existingSource = map.getSource(sourceId) as GeoJSONSource;
                if (existingSource) {
                    existingSource.setData(source.data);
                } else {
                    map.addSource(sourceId, source);
                }
            } else {
                map.removeSource(sourceId);
            }
        } catch (error: any) {
            console.error(`Error setting source ${sourceId}: ${error.message}`);
        }
    };
};